import { SaleTypeContainer } from '../../containers/advancedFilters/SaleTypeContainer';
import { IFilter } from '../../types/filters';

export const saleType: IFilter = {
  component: SaleTypeContainer,
};
